import { ALLOWED_SYMBOLS_BEFORE_ENTITY } from '../../getSymbolsChecks.constants';
import { IKeyWordSymbolsHandlerOptions, ISymbolsHandler } from '../../getSymbolsChecks.types';
import { isValidStartPosition } from '../../utils/isValidStartPosition/isValidStartPosition';

export const handlerKeyWord =
  ({ keyWord, keyWordType, symbolHandler }: IKeyWordSymbolsHandlerOptions): ISymbolsHandler =>
  (opts) => {
    const { text, index, symbolMatches } = opts;

    if (symbolHandler) {
      symbolHandler(opts);
    }

    if (
      !keyWord ||
      !keyWordType ||
      !isValidStartPosition({ text, index, allowedSymbols: ALLOWED_SYMBOLS_BEFORE_ENTITY })
    ) {
      return;
    }

    const keyWordStartIndex = index;
    const keyWordEndIndex = keyWordStartIndex + keyWord.length;
    const keyWordInText = text.substring(keyWordStartIndex, keyWordEndIndex);

    if (keyWordInText === keyWord) {
      symbolMatches[keyWord[0]].push({
        start: index,
        end: keyWordEndIndex,
        keyWord: { keyWordType, keyWord },
      });
    }
  };
